export interface UpdateNotificationMailTemplateRequest {
  id: number
  subject: string
  body: string
  revision: number
}

export function UpdateNotificationMailTemplateRequestToJSON(
  value: UpdateNotificationMailTemplateRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    subject: value.subject !== '' ? value.subject : undefined,
    body: value.body !== '' ? value.body : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
